<h1 class="header">{{data.title}}</h1>
<div mat-dialog-content>
    <p>{{data.content}}</p>
</div>
<div mat-dialog-actions class="justify-content-center">
    <button class="btn btn-primary" mat-button mat-dialog-close>{{data.buttonText}}</button>
</div>